import { combineReducers, configureStore } from '@reduxjs/toolkit'
import currentWalletAddressReducer from 'src/reducers/walletReducer';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import profileReducer from 'src/reducers/profileReducer';
import authReducer from 'src/reducers/authReducer';
import commonReducer from 'src/reducers/commonReducer';
import UserConfig from 'src/reducers/configReduser';
import saveGridModalReducer from 'src/reducers/gridLayoutReducer';
const persistConfig = {
  key: 'root',
  storage,
  whitelist:["oidc","walletAddress"]
}
const rootReducer = combineReducers({
  oidc: authReducer,
  walletAddress: currentWalletAddressReducer,
  profile:profileReducer,
  commonData:commonReducer,
  configData:UserConfig,
  gridLayout:saveGridModalReducer
})
const persistedReducer = persistReducer(persistConfig, rootReducer)
const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: [thunk]
})
export const persister = persistStore(store);
export default store